import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuoteApprovalComponent } from './quote-approval.component';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { ValidatorsModule } from '../../validators/validators.module';
import { PipesModule } from '../../pipes/pipes.module';

/**
 * TODO: check if this can be lazy loaded
 */

@NgModule({
  declarations: [QuoteApprovalComponent],
  exports: [QuoteApprovalComponent],
    imports: [
        CommonModule,
        CheckboxModule,
        FormsModule,
        ValidatorsModule,
        PipesModule,
    ]
})
export class QuoteApprovalModule { }
